import * as React from "react";
const SvgFiRrGasPump = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-gas-pump_svg__a)">
      <path
        fill="#062147"
        d="M23.681 3.267a1 1 0 0 0-1.414 0L19.293 6.24a1 1 0 0 0-.293.707V18a1 1 0 0 1-1 1h-2V5a5.006 5.006 0 0 0-5-5H5a5.006 5.006 0 0 0-5 5v14a5.006 5.006 0 0 0 5 5h6a5 5 0 0 0 4.576-3H18a3 3 0 0 0 3-3V7.361l2.681-2.68a1 1 0 0 0 0-1.414M5 2h6a3 3 0 0 1 3 3v4h-2a3.97 3.97 0 0 0-.985-2.6l.692-.693a1 1 0 1 0-1.414-1.414l-.954.954A3.962 3.962 0 0 0 4 9H2V5a3 3 0 0 1 3-3m1 7a2 2 0 1 1 4 0zm5 13H5a3 3 0 0 1-3-3v-8h12v8a3 3 0 0 1-3 3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-gas-pump_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGasPump;
